"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXCHANGE_PIONEX_SWAP = exports.EXCHANGE_PIONEXV2 = void 0;
exports.EXCHANGE_PIONEXV2 = "pionex.v2";
exports.EXCHANGE_PIONEX_SWAP = "pionex.binance.swap";
